/**
 * Shared client-side auth field validators. Password length is 8+ to match
 * server/src/middleware/validate/authSchemas.ts (a 6-char password would pass
 * the UI and fail registration). Special character is an extra client rule.
 */

export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const PASSWORD_RULES = [
  { id: 'length', test: (p: string) => p.length >= 8, label: 'At least 8 characters' },
  { id: 'upper', test: (p: string) => /[A-Z]/.test(p), label: 'One uppercase letter' },
  { id: 'lower', test: (p: string) => /[a-z]/.test(p), label: 'One lowercase letter' },
  { id: 'number', test: (p: string) => /[0-9]/.test(p), label: 'One number' },
  { id: 'special', test: (p: string) => /[^A-Za-z0-9]/.test(p), label: 'One special character' },
] as const;

export function validateEmail(email: string): string | null {
  const value = email.trim();
  if (!value) return 'Email is required';
  if (!EMAIL_RE.test(value)) return 'Please enter a valid email address';
  return null;
}

export function validateName(name: string): string | null {
  const value = name.trim();
  if (!value) return 'Name is required';
  if (value.length < 3) return 'Name must be at least 3 characters';
  return null;
}

export function validatePassword(password: string): string | null {
  if (!password) return 'Password is required';
  const failed = PASSWORD_RULES.find((rule) => !rule.test(password));
  return failed ? failed.label : null;
}

export function validateLoginPassword(password: string): string | null {
  if (!password) return 'Password is required';
  return null;
}

export function validateCurrentPassword(password: string): string | null {
  if (!password) return 'Current password is required';
  return null;
}

export function validateConfirmPassword(password: string, confirm: string): string | null {
  if (!confirm) return 'Confirm password is required';
  if (confirm !== password) return 'Passwords do not match';
  return null;
}

export function validateAgreeToTerms(agreed: boolean): string | null {
  if (!agreed) return 'You must agree to the Terms of Service';
  return null;
}
